<div *ngIf="isExpanded" class="api-access-card" (click)="openApiKeysModal()">
  <div class="api-access-left">
    <span class="material-icons api-access-icon">api</span>
    <span class="api-access-text">Get API Access</span>
  </div>
  <span class="api-access-plus">+</span>
</div>

<app-api-keys-modal #apiKeysModal></app-api-keys-modal>
